import { useDispatch } from 'react-redux';
import { setNavItems } from 'src/redux/navItems/navItemsSlice';
import { logout as userLogOut } from 'src/redux/user/userSlice';
import useApi from '../useApi';
import { persistor } from 'src/store';

export const useLogout = () => {
  const dispatch = useDispatch();

  const {
    data: logoutData,
    loading: logoutLoading,
    error: logoutErr,
    postData,
  } = useApi('/Common/logout');

  const logout = async () => {
    await postData();

    dispatch(userLogOut());
    dispatch(setNavItems([]));
    persistor.purge();
    window.location.href = `${window.location.origin}/#/?t=${Date.now()}`;
  };

  return { logoutData, logoutLoading, logoutErr, logout };
};
